import {Skeleton, Text} from '@smart/react-components';
import * as React from 'react';

export interface PriceProps {
  readonly value: string | undefined;
  readonly loading: boolean;
}

export function Price({value, loading}: PriceProps): JSX.Element {
  return (
    <Skeleton height={`56px`} width={`180px`} loading={loading || !value}>
      <Text variant="d-200">{value}</Text>
    </Skeleton>
  );
}
